import merchants from 'services/merchants'

export default {
  parseSaleOptionCodename (usageRight) {
    var merchant = usageRight.transaction.merchant

    if (!merchants.isPaid(merchant)) {
      var codename = usageRight.transaction.inapp_product_id.split('.')[1]
      return codename
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/usageRights.js